export default [
  'Natasha',
  'NTS-AL00',
  'Tony',
  'TNY-AL00',
  'TNY-AL10',
  'TNY-TL00',
  'Elizabeth',
  'ELZ-AN00',
  'Elizabeth',
  'ELZ-AN10',
  'Elizabeth',
  'ELZ-AN20',
  'Maggie',
  'MGI-AN00',
  'Lange',
  'LGE-AN00',
  'Lange',
  'LGE-AN10',
  'Lange',
  'LGE-AN20',
  'Ferrari',
  'FRI-AN00',
  'Ferrari',
  'FRI-AN10',
  'Piaget',
  'PGT-AN00',
  'Piaget',
  'PGT-AN10',
  'Piaget',
  'PGT-AN20',
  'Veyron',
  'VER-AN10',
  'Veyron',
  'VER-AN10',
  'Veyron',
  'VER-AN10',
  'Veyron',
  'VER-AN00',
  'Bvlgari',
  'BVL-AN00',
  'Bvlgari',
  'BVL-AN16',
  'Bvlgari',
  'BVL-AN20',
  'Bvlgari',
  'BVL-AN20',
  'Lyra',
  'LRA-AN00',
  'FalconP',
  'FCP-AN10',
  'FCP-AN20',
  'Falcon',
  'FLC-AN00',
  'Philippe',
  'PTP-AN00',
  'PTP-AN60',
  'Patek',
  'PTP-AN10',
  'PTP-AN70',
  'Patek',
  'PTP-AN20',
  'Maybach',
  'MBH-AN10',
  'Celine',
  'CLE-AN00',
  'BKQ-AN00',
  'BKQ-AN80',
  'BKQ-AN10',
  'BKQ-AN90',
  'Mogolia',
  'H60-L01',
  'H60-L02',
  'H60-L03',
  'H60-L11',
  'H60-L12',
  'H60-L21',
  'Pine',
  'PE-TL00M',
  'PE-TL10',
  'PE-TL20',
  'PE-UL00',
  'PE-CL00',
  'Plank',
  'PLK-AL10',
  'PLK-TL01H',
  'PLK-TL00',
  'PLK-TL11H',
  'PLK-UL00',
  'PLK-CL00',
  'ATH-AL00',
  'ATH-TL00H',
  'ATH-TL00',
  'ATH-UL00',
  'ATH-CL00',
  'Faraday',
  'FRD-AL00',
  'FRD-AL10',
  'FRD-TL00',
  'FRD-DL00',
  'Prague',
  'PRA-AL00',
  'PRA-AL00X',
  'PRA-TL10',
  'Stanford',
  'STF-AL00',
  'STF-AL10',
  'STF-TL10',
  'Leland',
  'LLD-AL00',
  'LLD-AL10',
  'LLD-TL10',
  'LelandP',
  'LLD-AL20',
  'LLD-AL30',
  'Columbia',
  'COL-AL00',
  'COL-AL10',
  'COL-TL00',
  'COL-TL10',
  'Harry',
  'HRY-AL00',
  'HRY-AL00a',
  'HRY-TL00',
  'Harrypro',
  'HRY-AL00T',
  'HRY-AL00Ta',
  'HRY-TL00T',
  'Yale',
  'YAL-AL00',
  'YAL-TL00',
  'Yale',
  'YAL-AL10',
  'YAL-TL10',
  'Yalese',
  'YAL-AL50',
  'YAL-TL50',
  'Laura',
  'LRA-AL00',
  'LRA-TL00',
  'Birmingham',
  'BMH-AN10',
  'BMH-AN20',
  'BMH-TN10',
  'BMH-TN20',
  'Edinburgh',
  'EBG-AN00',
  'EBG-TN00',
  'Edinburgh',
  'EBG-AN10',
  'CindyH',
  'CDY-AN90',
  'CDY-AN95',
  'CDY-TN90',
  'CDY-TN95',
  'Maxwell',
  'MXW-AN00',
  'MXW-TN00',
  'Nottingham',
  'NTH-AN00',
  'Rena',
  'RNA-AN00',
  'RNA-TN00',
  'JuliaH',
  'JLH-AN00',
  'Lisa',
  'LSA-AN00',
  'Tina',
  'TNA-AN00',
  'TNA-TN00',
  'Gina',
  'GIA-AN00',
  'Fennie',
  'FNE-AN00',
  'Sandy',
  'SDY-AN00',
  'Hepburn',
  'HPB-TN00',
  'Anna',
  'ANN-AN00',
  'AnnaP',
  'ANP-AN00',
  'AnnaB',
  'ANB-AN00',
  'Gina',
  'GIA-AN80',
  'AnnaGT',
  'AGT-AN00',
  'Rhea',
  'REA-AN00',
  'RheaP',
  'REP-AN00',
  'MiaGT',
  'MAG-AN00',
  'Mia',
  'MAA-AN00',
  'MiaP',
  'MAA-AN10',
  'Ellie',
  'ELI-AN00',
  'EllieP',
  'ELP-AN00',
  'AMM-AN00',
  'AMP-AN00',
  'AMP-AN10',
  'DNN-AN00',
  'DNP-AN00',
  'Merry',
  'MEY-AN00',
  'MerryP',
  'MEP-AN00',
  'Knight',
  'KNT-AL10',
  'KNT-AL20',
  'KNT-TL10',
  'KNT-UL10',
  'Duke',
  'DUK-AL20',
  'DUK-TL30',
  'Berkeley',
  'BKL-AL00',
  'BKL-AL10',
  'BKL-AL20',
  'BKL-TL10',
  'Princeton',
  'PCT-AL10',
  'PCT-TL10',
  'OxfordS',
  'OXF-AN00',
  'OxfordP',
  'OXF-AN10',
  'York',
  'YOK-AN10',
  'ALA-AN70',
  'Victoria',
  'VCA-AN00',
  'AMG-AN00',
  'PhilippeGT',
  'PPG-AN00',
  'G750-T00',
  'G750-U00',
  'G750-T20',
  'G750-T01',
  'Cherry',
  'Che1-CL20',
  'Che1-CL10',
  'Cherryplus',
  'Che2-TL00',
  'Che2-TL00H',
  'Che2-TL00M',
  'CHE-TL00H',
  'CHE-TL00',
  'Che2-UL00',
  'Kiwi',
  'KIW-AL10',
  'KIW-TL00H',
  'KIW-TL00',
  'KIW-UL00',
  'KIW-CL00',
  'Berlin',
  'BLN-AL10',
  'BLN-AL20',
  'BLN-AL30',
  'BLN-AL40',
  'BLN-TL00',
  'BLN-TL10',
  'Bond',
  'BND-AL00',
  'BND-AL10',
  'BND-TL10',
  'Johnson',
  'JSN-AL00',
  'JSN-AL00a',
  'JSM-TL00',
  'Ares',
  'ARE-AL00',
  'ARE-AL10',
  'ARE-TL00',
  'Hulk',
  'HLK-AL00',
  'HLK-AL00a',
  'HLK-TL00',
  'Hulk',
  'HLK-AL10',
  'Teller',
  'TEL-AN00',
  'TEL-AN00a',
  'TEL-AN10',
  'TEL-TN00',
  'TEL-TN10',
  'Kingkong',
  'KKG-AN00',
  'NewtonH',
  'NTN-AN20',
  'Chanel',
  'CHL-AN00',
  'Andy',
  'ANY-AN00',
  'Tiffany',
  'TFY-AN00',
  'Kingkong',
  'KKG-AN70',
  'Rambo',
  'RMO-AN00',
  'Dior',
  'DIO-AN00',
  'AndyGT',
  'ADT-AN00',
  'Ali',
  'ALI-AN00',
  'AliP',
  'ALP-AN00',
  'Cartier',
  'CRT-AN00',
  'Lily',
  'LLY-AN00',
  'Bruce',
  'BRC-AN00',
  'BruceP',
  'BRP-AN00',
  'BRP-AN80',
  'LilyN',
  'LYN-AN00',
  'AGI-AN00',
  'MTN-AN00',
  'MTN-AN80',
  'Amber',
  'ABR-AN00',
  'Jimmy',
  'JMM-AL00',
  'JMM-AL10',
  'JMM-TL00',
  'JMM-TL10',
  'Cornell',
  'COR-AL00',
  'COR-AL10',
  'COR-TL10',
  'Asoka',
  'ASK-AL00x',
  'ASK-AL20',
  'ASK-TL00x',
  'Katyusha',
  'KSA-AL10',
  'Asoka',
  'AKA-AL10',
  'Aquaman',
  'AQM-AL10',
  'TianshanH',
  'TNNH-AN00',
  'OxfordPL',
  'OXP-AN00',
  'JessicaH',
  'HJC-AN90',
  'NewtonH',
  'NEW-AN90',
  'KonanZ',
  'KOZ-AL40',
  'Nezha',
  'NZA-AL00',
  'Chanel',
  'CHL-AL00',
  'Carmella',
  'CMA-AN40',
  'Tiffany',
  'TFY-AN40',
  'Vinnie',
  'VNE-AN40',
  'Rocky',
  'RKY-AN10',
  'Dior',
  'DIO-AN00',
  'Clark',
  'CLK-AN00',
  'Lily',
  'LLY-AN00',
  'Alita',
  'ALT-AN00',
  'LYN-AN00',
  'Judy',
  'JDY-AN00',
  'Logan',
  'LOG-AN10',
  'Nick',
  'NIC-AN00',
  'David',
  'DVD-AN00',
  'DVD-AN80',
  'Edison',
  'EDI-AL10',
  'EDI-DL00',
  'Ravel',
  'RVL-AL09',
  'H30-T00',
  'H30-T10',
  'H30-U10',
  'H30-L01',
  'H30-L01M',
  'H30-L02',
  'H30-C00',
  'Holly',
  'Hol-T00',
  'Hol-U10',
  'Cherrymini',
  'CHM-TL00H',
  'CHM-TL00',
  'CHM-UL00',
  'CHM-CL00',
  'Scale',
  'SCL-AL00',
  'SCL-TL00H',
  'SCL-TL00',
  'SCL-CL00',
  'G621-TL00M',
  'G621-TL00',
  'G620S-UL00',
  'C8817D',
  'Nemo',
  'NEM-AL10',
  'NEM-TL00H',
  'NEM-TL00',
  'NEM-UL00',
  'Cambodia',
  'CAM-AL00',
  'CAM-TL00H',
  'CAM-TL00',
  'CAM-UL00',
  'CAM-CL00',
  'Cancun',
  'CUN-AL00',
  'CUN-TL00',
  'Delhi',
  'DLI-AL10',
  'DLI-TL20',
  'Maya',
  'MYA-AL10',
  'MYA-TL10',
  'London',
  'LND-AL30',
  'LND-AL40',
  'LND-TL30',
  'LND-TL40',
  'Atomu',
  'AUM-AL00',
  'AUM-AL20',
  'AUM-TL00',
  'AUM-TL20',
  'Dura',
  'DUA-AL00',
  'DUA-TL00',
  'Bangkok',
  'BKK-AL00',
  'BKK-AL10',
  'BKK-TL00',
  'Jakarta',
  'JAT-AL00',
  'JAT-TL00',
  'Katyusha',
  'KSA-AL00',
  'KSA-TL00',
  'Moana',
  'MOA-AL00',
  'MOA-AL20',
  'MOA-TL00',
  'KonanZ',
  'KOZ-AL00',
  'KonanZ',
  'KOZ-AL00CM',
  'JessicaH',
  'HJC-LX9',
  'Vinnie',
  'VNE-AN00',
  'Vinnie',
  'VNE-AN40',
  'Carmella',
  'CMA-AN00',
  'Woody',
  'WDY-AN00',
  'Rocky',
  'RKY-AN00',
  'Judy',
  'JDY-AN00',
  'Clark',
  'CLK-AN00',
  'Nick',
  'NIC-AN00',
  'NLA-AN00',
  'Alita',
  'ALT-AN00',
  'Logan',
  'LOG-AN00',
  'S8-701w',
  'S8-701u',
  'T1-821w',
  'T1-823L',
  'Jordan',
  'JDN-W09',
  'JDN-AL00',
  'Agassi2',
  'AGS2-W09HN',
  'AGS2-AL00HN',
  'Jordan2',
  'JDN2-W09HN',
  'JDN2-AL00HN',
  'JDN-AL50HN',
  'Agassi3',
  'AGS3-W09HN',
  'AGS3-AL09HN',
  'Agassi3M',
  'AGM3-W09HN',
  'AGM3-AL09HN',
  'Hendry',
  'HEY-W09',
  'Hendry2',
  'HEY2-W09',
  'HEY2-W19',
  'Rolland',
  'ROD-W09',
  'ROD-W19',
  'Hendry3',
  'HEY3-W00',
  'HEY3-W10',
  'Karajan',
  'KRJ-W09',
  'KRJ-AN00',
  'KarajanR',
  'KJR-W09',
  'Karajan2',
  'KRJ2-W09',
  'KRJ2-AN00',
  'Britten',
  'BRT-W09',
  'BRT-AN09',
  'Britten',
  'BRT-W09',
  'Rolland',
  'ROD-W09',
  'Rowling',
  'ROL-W00',
  'ROL-W10',
  'Gaudi',
  'GDI-W09',
  'Rolland2',
  'ROD2-W09',
  'Changan',
  'CGA-W00',
  'CGL-W00',
  'YLP-W00',
  'Rowling',
  'ROL-W60',
  'Rolland2',
  'ROD2-W69',
  'CHG-W60',
  'AgassiR',
  'AGR-W09HN',
  'AGR-AL09HN',
  'Kobe2',
  'KOB2-W09HN',
  'KOB2-AL00HN',
  'Agassi3M',
  'AGM3-W09HN',
  'Eileen',
  'ELN-W09',
  'Nadal',
  'NDL-W09',
  'NDL-AL00',
  'Eileen2',
  'ELN2-W09',
  'AgassiRM',
  'AGM-W09HN',
  'AGM-AL09HN',
  'Agassi3M',
  'AGM3-W09HN',
  'AGM3-AL09HN',
  'Eileen',
  'ELN-W09',
  'Hendry2',
  'HEY2-AN00',
  'Haydn',
  'HDN-W09',
  'HDN-L09',
  'Handel',
  'HDL-W09',
  'HDL-AL09',
  '7D-501u',
  '7D-503L',
  '7D-503LT',
  'GEM-703L',
  'GEM-703LT',
  'T1-701u',
  'T1-701ua',
  'Baggio',
  'BGO-DL09',
  'T1-A21w',
  'T1-A23L',
  'Kobe',
  'KOB-W09',
  'KOB-L09',
  'Agassi',
  'AGS-W09',
  'AGS-L09',
  'Baggio2',
  'BG2-W09',
  'Volta',
  'VLT-W50',
  'VLT-W60',
  'KPL-W00',
  'VoltaR',
  'VLR-W09',
  'VLR-W19',
  'VLR-W29',
  'VLR-W09L',
  'VLR-W19L',
  'VLR-W19LP',
  'VLR-W29L',
  'KPR-W19',
  'KPR-W29',
  'KPRC-W10L',
  'KPRC-W20L',
  'NobelB',
  'Nbl-WAH9HN',
  'Nbl-WAH9HNP',
  'Nbl-WAE9HN',
  'Nbl-WAE9HNP',
  'NobelK',
  'Nbl-WAQ9HNR',
  'Nbl-WAQ9HNRP',
  'Nbl-WAP9HNR',
  'Nbl-WAQ9HNL',
  'Nbl-WAP9HNL',
  'NobelL',
  'NblL-WFQ9HN',
  'NblL-WFP9HN',
  'NobelD',
  'NbD-WFH9HN',
  'NbD-WFE9HN',
  'NobelDR',
  'NDR-WFH9HN',
  'NDR-WFE9HN',
  'NobelLR',
  'NLR-WAQ9HNR',
  'Nbl-WAQ9HNRP',
  'NIR-WAP9HNRP',
  'NobelMH',
  'NMH-WDQ9HN',
  'NMH-WFQ9HN',
  'NMH-WFP9HN',
  'GalileoF',
  'GLO-F56',
  'GLO-F76',
  'GalileoN',
  'GLO-N56',
  'GLO-N76',
  'GalileoG',
  'GLO-G56',
  'GLO-G561',
  'GLO-G52',
  'GalileoG',
  'GLO-G561',
  'BohrB',
  'Boh-WAH9HN',
  'Boh-WAH9HNP',
  'Boh-WAE9HN',
  'BohrK',
  'Boh-WAQ9HNR',
  'Boh-WAQ9HNRP',
  'Boh-WAP9HNR',
  'Boh-WAQ9HNL',
  'Boh-WAP9HNL',
  'BohrL',
  'BohL-WDQ9HN',
  'BohL-WFQ9HN',
  'BohL-WFP9HN',
  'BohrD',
  'BoD-WFH9HN',
  'BoD-WFE9HN',
  'BohrDR',
  'BDR-WFH9HN',
  'BDR-WFE9HN',
  'BohrMH',
  'BMH-WDQ9HN',
  'BMH-WFQ9HN',
  'BMH-WFP9HN',
  'HBL-W19',
  'HBL-W29',
  'HBL-W19L',
  'HBL-W29L',
  'HalleyK',
  'HLY-W19R',
  'HLY-W19RP',
  'HLY-W29R',
  'HLY-W19RL',
  'HLY-W19RLP',
  'HLY-W29RL',
  'HBB-WAH9PHNL',
  'HBB-WAE9PHNL',
  'HalleyL',
  'HLYL-WFQ9',
  'HLYL-WFP9',
  'HalleyLR',
  'HYLR-WDQ9',
  'HYLR-WFP9',
  'HalleyM',
  'HYM-W56',
  'HYM-W76',
  'HalleyM',
  'HYM-W76',
  'DarwinA',
  'DRA-56',
  'DRA-54',
  'DRA-72',
  'DarwinB',
  'DRB-P',
  'FMB-P',
  'FMB-PM',
  'HiggsE',
  'HGE-W56',
  'HGE-W76',
  'HiggsF',
  'HGF-W56',
  'HGF-W76',
  'MooreA',
  'MRA-561',
  'MRA-521',
  'MRA-721',
  'MooreO',
  'MRO-521',
  'MooreB',
  'MRB-A',
  'NobelBR',
  'NBR-WAI9',
  'NBR-WAH9',
  'NobelDR',
  'NDR-WFH',
  'FermiF',
  'FRI-F56',
  'FermiF',
  'FRI-F38',
  'FRI-F56',
  'FRI-F561',
  'FermiG',
  'FRI-G56',
  'FRI-G561',
  'FermiH',
  'FRI-H76',
  'FermiG',
  'FRI-G56',
  'FRI-G561',
  'FermiH',
  'FRI-H56',
  'FermiG',
  'FRG-X',
  'GodelG',
  'GDG-X',
  'FermiG',
  'FRG-X',
  'GodelH',
  'GDH-X',
  'FermiI',
  'FMI-76',
  'FMI-721',
  'FermiB',
  'FRB-X',
  'BohrBR',
  'BBR-WAI9',
  'BBR-WAH9',
  'BohrDR',
  'BDR-WDH',
  'BDR-WFH',
  'BornF',
  'BRN-F56',
  'BornF',
  'BRN-F56',
  'BRN-F561',
  'BornG',
  'BRN-G56',
  'BRN-G561',
  'BornH',
  'BRN-H76',
  'BornG',
  'BRN-G56',
  'BRN-G561',
  'BornH',
  'BRN-H56',
  'BornG',
  'BRG-585',
  'BRG-565',
  'BRG-561',
  'BRG-765',
  'BRG-761',
  'BornG',
  'BRG-X',
  'GOH-X',
  'BornI',
  'BRI-76',
  'BRI-721',
  'BornB',
  'BRB-X',
  'FermiF',
  'FRI-F56Z',
  'FRD-WDG9',
  'FRD-WFG9',
  'FRD-WFD9',
  'FRR-WFG9',
  'FRR-WFD9',
  'Oscar',
  'OSCA-550A',
  'OSCA-550AX',
  'Oscar',
  'OSCA-550',
  'OSCA-550X',
  'HN65TAG',
  'HN75TAG',
  'Locke',
  'LOK-330',
  'LOK-350',
  'LOK-350C',
  'LOK-350S',
  'HN55LOKS',
  'LOK-360',
  'LOK-360C',
  'LOK-360S',
  'HN65LOKS',
  'LOK-370',
  'HN43DNTA',
  'HN55DNTA',
  'HN65DNTA',
  'HN55DNTS',
  'HN65DNTS',
  'HN55BYRA',
  'HN65BYRA',
  'HN75BYRA',
  'HN43DNTH',
  'HN55BYRA',
  'TLS-B19',
  'HBE-B19',
  'HBE-B39',
  'Minos',
  'MNS-B19',
  'MNS-B39',
  'HES-B19',
  'HES-B59',
  'KAN-B19',
  'KAN-B39',
  'MUS-B19',
  'MNS-B39',
  'TMA-L19',
  'TUM-L19',
  'MUS-B19',
  'STL-L19',
  'Halo',
  'HAL-L19',
  'Tumir',
  'TUR-L19',
  'IVY-B39',
  'LWS-WB10',
  'NYX-B10HN',
  'NYX-B20HN',
  'Crius',
  'CRS-B19',
  'CRS-B29',
  'AW70-B19HN',
  'Crius',
  'CRS-B19S',
  'CRS-B29S',
  'CRS-B39',
  'CRS-B59',
  'ADS-B19',
  'AW70-B39HN',
  'ARG-B19',
  'ARG-B29',
  'ARG-B39',
  'ARG-B59',
  'FLA-B19',
  'FLA-B39',
  'RHE-B19',
  'RHE-B39',
  'VNE-B19',
  'VNE-B39',
  'CGN-A00',
]